import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import i18n, { resolveSupportedLocale } from "./i18n";
import { store } from "@/store";
import VueGtag from "vue-gtag-next";
import { initCustomerio, trackPage } from "@/customerio";
import { resolveExtensionLocale } from "@/shared-helpers/language.helper";
import authHelper from "@/helpers/authHelper";
import "@payjoy/design-system/style.css";

const app = createApp(App);

app.use(router);
app.use(i18n);
app.use(store);
app.use(VueGtag, {
  property: {
    id: (process.env.VUE_APP_GTM_ID as string) || "",
  },
});

initCustomerio();

router.beforeEach((to, from, next) => {
  if (to.params.deviceTag) {
    store.dispatch("payOptions/setDeviceTag", to.params.deviceTag);
  }
  if (to.query.paymentOption) {
    store.dispatch("payOptions/setPaymentOption", to.query.paymentOption);
  }
  if (to.query.country) {
    store.dispatch("payOptions/setCountry", to.query.country);
  }
  if (to.query.selectedInstallment) {
    store.dispatch("payOptions/setSelectedInstallment", to.query.selectedInstallment);
  }
  if (to.query.currencySymbol) {
    store.dispatch("payOptions/setCurrencySymbol", to.query.currencySymbol);
  }
  if (to.query.phoneNumber) {
    store.dispatch("payOptions/setPhoneNumber", to.query.phoneNumber);
  }
  const extensionRouteNames = ["ExtensionTypeView", "ExtensionReasonView"];
  if (extensionRouteNames.includes(to.name as string)) {
    const resolved = resolveExtensionLocale(to.query.lang as string | undefined);
    i18n.global.locale.value = resolved;
    document.cookie = `django_language=${resolved.toLowerCase()}; path=/`;
  }
  // PYMT-2285: the v1 flow sets the whole-app language from a caller-supplied
  // locale — the `?lang=` query param, or (when absent) the browser language
  // (its Accept-Language) — so either the query param or the header drives it.
  if (to.name === "V1InstallmentsByDevice") {
    i18n.global.locale.value = resolveSupportedLocale(to.query.lang as string | undefined);
  }
  next();
});

router.afterEach(() => {
  // Report a page view to Customer.io on every route change so in-app page rules
  // are evaluated for each screen of this single-page app.
  trackPage();
});

app.mount("#app");
